import { clsx } from 'clsx';
import { HTMLProps, SVGProps } from 'react';
import { ReactComponent as IconChevron } from './icon-chevron.svg';
import { ReactComponent as IconGlobe } from './icon-globe.svg';
import { ReactComponent as IconCheckmark } from './icon-checkmark.svg';
import { ReactComponent as IconWarning } from './icon-warning.svg';
import { ReactComponent as IconError } from './icon-error.svg';

export type IconName =
    | 'account'
    | 'ages14up'
    | 'ages17up'
    | 'ages2to6'
    | 'ages7up'
    | 'allaudiences'
    | 'android'
    | 'apple'
    | 'attachment'
    | 'attention'
    | 'audiobook'
    | 'back-arrow'
    | 'bookshelf'
    | 'calendar'
    | 'card'
    | 'check'
    | 'checked'
    | 'checkmark'
    | 'chevron'
    | 'clear'
    | 'copies'
    | 'down-arrow'
    | 'download'
    | 'ebook'
    | 'edit'
    | 'email'
    | 'error'
    | 'facebook'
    | 'facebook2'
    | 'forward-arrow'
    | 'g'
    | 'globe'
    | 'globe2'
    | 'google-plus'
    | 'grid'
    | 'hamburger'
    | 'help'
    | 'hide'
    | 'history'
    | 'holds'
    | 'info'
    | 'kindle-logo'
    | 'large-left-arrow'
    | 'large-right-arrow'
    | 'library'
    | 'list'
    | 'listen'
    | 'magazine'
    | 'more'
    | 'music'
    | 'narrated-ebook'
    | 'nc17'
    | 'od-logo'
    | 'overdrive'
    | 'periodicals'
    | 'pg'
    | 'pg13'
    | 'pinterest'
    | 'podcast'
    | 'powered-by-od'
    | 'r'
    | 'radio-selected'
    | 'radio-unselected'
    | 'renew'
    | 'return'
    | 'search-nav'
    | 'settings'
    | 'show'
    | 'speech'
    | 'timer'
    | 'tumblr'
    | 'tv14'
    | 'tv7'
    | 'tvg'
    | 'tvma'
    | 'tvpg'
    | 'tvy'
    | 'tvy7fv'
    | 'twitter'
    | 'unchecked'
    | 'up-arrow'
    | 'video'
    | 'warning'
    | 'windows'
    | 'wish-list-added'
    | 'wish-list'
    | 'youtube';

interface IconProps extends HTMLProps<HTMLElement> {
    /**
     * @deprecated Use the `className` prop instead.
     */
    classes?: string;
    name: IconName;
}

export const Icon = (props: IconProps) => {
    const { classes, className, name, ...rest } = props;
    let extraClass;
    const svgProps = rest as SVGProps<SVGSVGElement>;

    switch (name) {
        case 'globe2':
            return <IconGlobe {...svgProps} />;
        case 'chevron':
            return <IconChevron {...svgProps} />;
        case 'checkmark':
            return <IconCheckmark {...svgProps} />;
        case 'warning':
            return <IconWarning height="20" width="20" {...svgProps} />;
        case 'error':
            return <IconError height="20" width="20" {...svgProps} />;
        case 'card':
            extraClass = 'modal';
            break;
        case 'large-left-arrow':
            rest.style = { visibility: 'visible' };
            break;
        default:
            break;
    }

    return (
        <i
            className={clsx(
                'icon',
                `icon-${name}`,
                classes,
                className,
                extraClass
            )}
            {...rest}
        />
    );
};
